import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { IHaveDescription } from "../../../common/have-description.interface";
import { IHaveName } from "../../../common/have-name.interface";
import { Dropdown } from 'primeng/dropdown';

@Component({
  selector: 'app-eca-select',
  templateUrl: './eca-select.component.html',
  styleUrls: ['./eca-select.component.scss']
})
export class EcaSelectComponent implements OnInit {
  @Input() selectedId: IHaveName;
  @Input() isReadOnly: boolean;
  @Input() options: IHaveName[] = [];
  @Input() isRequired: boolean = false;
  @Input() popoverText: string = "";
  @Input() label: string = "";
  @Input() validationMessage: string = "";
  @Input() isValid: boolean = true;
  @Input() updateMessage: string = "";
  @Input() showUpdateMessage: boolean = false;
  @Input() controlId: string = 'ctrlSelect';
  @Input() enableClear: boolean = false;
  @Input() placeholderText: string = "";
  @Output() selectedIdChange: EventEmitter<any> = new EventEmitter<any>();

  allowClear: boolean = false;

  constructor(private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.allowClear = !this.isRequired;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.options?.currentValue) {
      this.options = changes.options.currentValue;
      this.cdr.detectChanges(); // Trigger change detection manually
    }
    
    if (changes.selectedId?.currentValue) {
      this.selectedId = changes.selectedId.currentValue;
      this.cdr.detectChanges(); // Trigger change detection manually
    }

    if (changes.showUpdateMessage?.currentValue) {
      this.showUpdateMessage = changes.showUpdateMessage.currentValue;
      this.cdr.detectChanges(); // Trigger change detection manually
    }
  }

  selectedIdChanged() {
    this.selectedIdChange.emit(this.selectedId);
  }

}
